export default __webpack_public_path__ + "static/media/team-phone-img.2028e705.png";